"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFabricVideoOptionsPlayer = exports.isFabricVideoOptions = void 0;
const objects_1 = require("./objects");
exports.isFabricVideoOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === objects_1.ObjectType.CustomVideo;
exports.isFabricVideoOptionsPlayer = (item) => (item === null || item === void 0 ? void 0 : item.type) === objects_1.ObjectType.CustomVideo;
//# sourceMappingURL=video.js.map